export const CHARTS_URL = 'dashboard'

export const CHARTS_TRANSACTION_PATH = `/project/:id/${CHARTS_URL}`
export const CHARTS_DETAIL_TRANSACTION_PATH = `/project/:id/${CHARTS_URL}/:dashboardId`
